module.exports = __webpack_public_path__ + "ptc_nakagawa_O2.20f519dc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/nakagawa/parent_to_child/ptc_nakagawa_O2.jpg
// module id = lEvm
// module chunks = 0